"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.valtraGlobalColors = void 0;
exports.valtraGlobalColors = {
    primary: {
        brand: '#E4002B',
        white: '#FFFFFF',
        black: '#1A1A1A',
        grays: {
            200: '#EAE9E9',
            400: '#D9D7D5',
            600: '#C5C1BE',
            800: '#A9A29C',
        },
    },
    secondary: {
        brand: '#BF0024',
        shades: {
            200: '#F2C4CD',
            400: '#EE93A4',
            600: '#EB627C',
            800: '#E73153',
        },
    },
};
